<template>
  <div class="franchisee__banner-form">
    <p class="franchisee__form-title">Speak to a Franchise Specialist</p>
    <p class="franchisee__form-subtitle">Chatting with us is convenient and completely confidential</p>

    <form action="https://iar.sbdinc.com/l/23162/2021-05-14/79wrdz" method="POST">
      <div class="fields franchisee__fields">
        <div class="lp-pom-form-field franchisee__form-left-column" id="container_First_Name">
          <label class="franchisee__label" for="First_Name">First Name</label>
          <input id="First_Name" name="First_Name" type="text" class="form__field form__field--text" placeholder="ie: John" required style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAfBJREFUWAntVk1OwkAUZkoDKza4Utm61iP0AqyIDXahN2BjwiHYGU+gizap4QDuegWN7lyCbMSlCQjU7yO0TOlAi6GwgJc0fT/fzPfmzet0crmD7HsFBAvQbrcrw+Gw5fu+AfOYvgylJ4TwCoVCs1ardYTruqfj8fgV5OUMSVVT93VdP9dAzpVvm5wJHZFbg2LQ2pEYOlZ/oiDvwNcsFoseY4PBwMCrhaeCJyKWZU37KOJcYdi27QdhcuuBIb073BvTNL8ln4NeeR6NRi/wxZKQcGurQs5oNhqLshzVTMBewW/LMU3TTNlO0ieTiStjYhUIyi6DAp0xbEdgTt+LE0aCKQw24U4llsCs4ZRJrYopB6RwqnpA1YQ5NGFZ1YQ41Z5S8IQQdP5laEBRJcD4Vj5DEsW2gE6s6g3d/YP/g+BDnT7GNi2qCjTwGd6riBzHaaCEd3Js01vwCPIbmWBRx1nwAN/1ov+/drgFWIlfKpVukyYihtgkXNp4mABK+1GtVr+SBhJDbBIubVw+Cd/TDgKO2DPiN3YUo6y/nDCNEIsqTKH1en2tcwA9FKEItyDi3aIh8Gl1sRrVnSDzNFDJT1bAy5xpOYGn5fP5JuL95ZjMIn1ya7j5dPGfv0A5eAnpZUY3n5jXcoec5J67D9q+VuAPM47D3XaSeL4AAAAASUVORK5CYII=&quot;); background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
        </div>
        <div class="lp-pom-form-field franchisee__form-right-column" id="container_Last_Name">
          <label class="franchisee__label" for="Last_Name">Last Name</label>
          <input id="Last_Name" name="Last_Name" type="text" class="form__field form__field--text" placeholder="ie: Smith" required>
        </div>
        <div class="lp-pom-form-field franchisee__form-left-column" id="container_email">
          <label class="franchisee__label" for="email">Email</label>
          <input id="email" name="email" type="email" class="form__field form__field--text" placeholder="ie: john@mactools.com" required>
        </div>
        <div class="lp-pom-form-field franchisee__form-right-column" id="container_Phone">
          <label class="franchisee__label" for="Phone">Phone Number</label>
          <input id="Phone" name="Phone" type="tel" class="form__field form__field--text" placeholder="ie: 8885551234" required pattern="^(\+?1[ -]?)?\(?[2-9]\d\d\)?[ -]?[2-9]\d\d[ -]?\d{4}$">
        </div>
        <div class="lp-pom-form-field single-line-text franchisee__form-left-column" id="container_Zip">
          <label class="franchisee__label" for="Zip">Zip Code</label>
          <input id="Zip" name="Zip" type="text" class="form__field form__field--text" placeholder="ie: 90210" required @blur="zipCodeHandleBlur" v-model="zipCode">
        </div>
        <div class="franchisee__form-right-column">
          <label class="franchisee__label" for="Country">Country</label>
          <div class="select-wrapper select-wrapper--primary" id="container_Country">
            <icon name="arrow-bottom" size="12px"/>
            <select id="Country" name="Country" required class="ub-input-item single form_elem_Country" v-model="country">
              <option value="United States">United States</option>
              <option value="Canada">Canada</option>
            </select>
          </div>
        </div>
        <div class="franchisee__form-full-column">
          <div class="select-wrapper select-wrapper--primary" id="container_Preferred_time_to_call">
            <icon name="arrow-bottom" size="12px"/>
            <select id="Preferred_time_to_call" name="Preferred_time_to_call" class="ub-input-item single form_elem_Preferred_time_to_call" required aria-label="Preferred time to call">
              <option value="">Best Time to Call</option>
              <option value="Mornings (8:00AM–12:00PM)">Mornings (8:00AM–12:00PM)</option>
              <option value="Afternoons (12:00-6:00PM)">Afternoons (12:00-6:00PM)</option>
              <option value="Evenings (6:00-9:00PM)">Evenings (6:00-9:00PM)</option>
            </select>
          </div>
        </div>

        <div class="franchisee__form-full-column">
          <div class="select-wrapper select-wrapper--primary" id="container_Found_us_by">
            <icon name="arrow-bottom" size="12px"/>
            <select id="Found_us_by" name="Found_us_by" class="ub-input-item single form_elem_Found_us_by" required v-model="foundUsBy" aria-label="Found Us By">
              <option value="">Found Us By</option>
              <option v-for="(item, index) in foundList" :key="index" :value="item.value">{{ item.label }}</option>
            </select>
          </div>
        </div>

        <div class="franchisee__form-full-column" v-if="foundUsBy === 'Referred by Mac Tools Distributor / Friend'">
          <label class="franchisee__label" for="Distributor">Name of Distributor/Friend</label>
          <input id="Distributor" name="Distributor" type="text" class="form__field form__field--text" required>
        </div>

        <div class="franchisee__checkbox-group" id="container_Agree_To_Emails">
          <div class="ub-input-item input-wrap optionsList" id="group_Agree_To_Emails">
            <div class="option" id="ub-option-Agree_To_Emails-item-0">
              <div class="checkbox-wrapper">
                <input type="checkbox" class="checkbox" id="Agree_To_Emails" required name="Agree_To_Emails" data-action="toggle-tag">
                <icon name="check" size="8px"/>
              </div>
              <label for="Agree_To_Emails" class="franchisee__checkbox-group-label"><span class="label-style">I agree to receive emails and text messages from Mac Tools with news, special offers, promotions and future messages tailored to my interests.</span></label>
            </div>
          </div>
        </div>
        <input id="Lead_Record_Type" name="Lead_Record_Type" type="hidden" class="hidden" value="012U00000005AL6 ">
        <input id="Form_Filled_URL" name="Form_Filled_URL" type="hidden" class="hidden" value="/pages/thank-you">
        <input id="City" name="City" type="hidden" class="hidden" value="" v-model="city">
        <input id="State" name="State" type="hidden" class="hidden" value="" v-model="state">
      </div>
      <button class="button button--primary button--full-width" id="lp-pom-button-438" type="submit"><span class="label">GET IN TOUCH</span></button>
      <p class="franchisee__form-disclaimer">You can unsubscribe at any time. See our <a target="_blank" href="https://www.stanleyblackanddecker.com/privacy-policy">Privacy Policy</a> or <a target="_blank" href="https://www.mactools.com/pages/contact-us">Contact Us</a> for more information</p>
    </form>
  </div>
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'FranchiseeBanner',

    components: { Icon },

    data() {
      return {
        foundUsBy: '',
        zipCode: '',
        country: 'United States',
        city: '',
        state: '',
        foundList: [
          {
            label: 'Career Site / Job Site',
            value: 'Career Site / Job Site'
          },
          {
            label: 'Careerbuilder',
            value: 'Careerbuilder'
          },{
            label: 'Craiglist / Kijiji',
            value: 'Craiglist / Kijiji'
          },
          {
            label: 'Email',
            value: 'Email'
          },
          {
            label: 'Event',
            value: 'Event'
          },
          {
            label: 'Facebook / Social Media',
            value: 'Facebook / Social Media'
          },
          {
            label: 'Google / YouTube',
            value: 'Google / YouTube'
          },
          {
            label: 'Mac Tools Sales Flyer',
            value: 'Mac Tools Sales Flyer'
          },
          {
            label: 'Monster',
            value: 'Monster'
          },
          {
            label: 'Press Release',
            value: 'Press Release'
          },
          {
            label: 'Referred by Mac Tools Distributor / Friend',
            value: 'Referred by Mac Tools Distributor / Friend'
          },
          {
            label: 'Text Message',
            value: 'Text Message'
          },
          {
            label: 'TV / Radio',
            value: 'TV / Radio'
          },
          {
            label: '614 Magazine',
            value: '614 Magazine'
          }
        ]
      }
    },
    methods: {
      zipCodeHandleBlur () {
        const countryCode = this.country === 'United States' ? 'US' : 'CA';
        const request = `https://secure.geonames.org/postalCodeLookupJSON?postalcode=${this.zipCode}&country=${countryCode}&style=long&username=Mluvaas`;
        fetch(request)
          .then((response) => response.json())
          .then((locationData) => {
            this.city = '';
            this.state = '';
            if(locationData.postalcodes.length === 1) {
              this.city = locationData.postalcodes[0].placeName;
              this.state = locationData.postalcodes[0].adminName1;
            }
          })
      }
    }
  }
</script>